export default {
  createSuccess: "¡Anfitrión creado correctamente!",
  createModal: {
    title: "Añadir anfitrión",
    namePlaceholder: "p. ej. Villa Panorama",
    emailPlaceholder: "host@example.com",
    create: "Crear anfitrión",
  },
  detail: {
    roleLabel: "Anfitrión",
    statStructures: "Estructuras",
    loadDetail: "Cargando datos del anfitrión...",
    loadError: "No se pudo cargar el anfitrión",
    toastStatusUpdated: "Estado del anfitrión actualizado",
    toastStatusError: "No se pudo actualizar el estado del anfitrión",
    toastPasswordResetSent: "Correo de restablecimiento enviado al anfitrión.",
    housesTitle: "Estructuras",
    noHouses: "Aún no hay estructuras",
    activitiesTitle: "Actividades ({{count}})",
    loadActivities: "Cargando actividades...",
    activitiesError: "No se pudieron cargar las actividades",
    noActivitiesTitle: "Sin actividades",
    noActivitiesDesc: "Este anfitrión aún no tiene actividades",
  },
} as const;
